module.exports = " Hint: to get a good idea of ledger entry types for upcoming years, make sure you have imported earlier ledger entries from your accounting software <crud-clerk-ledger-entry-type-curate></crud-clerk-ledger-entry-type-curate>";


//////////////////
// WEBPACK FOOTER
// .-dna/app/crud/clerk-ledger/steps/ledger-entry-types.html
// module id = 2508
// module chunks = 86